<template>
  <div class="shared-step-editor-input-counter">{{ input.length }}/{{ max }}</div>
</template>

<script setup>
export default {
  props: {
    input: String,
    max: Number,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.shared-step-editor-input-counter {
  all: unset;
  display: inline-block;
  font-size: 12px;
  text-align: right;
  width: 100%;
  color: $color-regent-grey;
  font-size: 11px;
}
</style>
